import React, { FC, useState } from 'react';
import { Marker as LeafletMarker } from 'react-leaflet';
import { MarkerProps } from '@utmb/types/map';
import MarkerIcon from './MarkerIcon';

const Marker: FC<MarkerProps> = ({ type, coords: { lat, lng }, children, color, events, eventView }) => {
    
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const markerEvent = {
        //...events,
        click: (e: any) => {
            setIsOpen(!isOpen);
            if(events?.click) events.click(e);
            
        },
    }

    return (
        <LeafletMarker position={[lat, lng]} icon={MarkerIcon({ type, color, eventView, isOpen }) as any} eventHandlers={markerEvent}>
            {children}
        </LeafletMarker>
    );
};

export default Marker;
